/**
 * Canonical floor-surface Y (world meters) for a room.
 *
 * `polygonCorners[0].y` is the floor-surface Y — it matches Floor.jsx and
 * vanity-assembly/placementUtils.js. `floor.center.y` can sit a couple of
 * inches higher when the floor record carries a thickness offset, so using it
 * as the primary source would float every kitchen object above the floor mesh;
 * it's only a fallback for floor records that lack cornered geometry.
 *
 * Shared by materializeCandidate, layoutKitchen, generateLayouts, and
 * kitchenWorkspace so the kitchen pipeline derives one consistent floor Y.
 *
 * @param {Object} roomData
 * @returns {number}
 */
function getFloorY(roomData) {
  const floors = roomData?.floors || [];
  if (!floors.length) return 0;
  const floor = floors[0];
  if (floor.polygonCorners && floor.polygonCorners.length > 0) {
    const y = floor.polygonCorners[0]?.y;
    if (typeof y === 'number') return y;
  }
  if (floor.center && typeof floor.center.y === 'number') return floor.center.y;
  return 0;
}

module.exports = { getFloorY };
